import { gql } from '@apollo/client'

export const FETCH_POSTS_QUERY = gql`
    {
        getPosts {
            id
            username
            body
            createdAt
            likeCount
            likes {
                username
            }
            commentCount
            comments {
                id
                username
                body
                createdAt
            }
        }
    }
`